import React from 'react';

const CancelIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="#C3C5CA" { ...rest }>
      <path d="M10 0.647461C15.5 0.647461 20 5.14746 20 10.6475C20 16.1475 15.5 20.6475 10 20.6475C4.5 20.6475 0 16.1475 0 10.6475C0 5.14746 4.5 0.647461 10 0.647461ZM10 2.64746C8.1 2.64746 6.4 3.24746 5.1 4.34746L16.3 15.5475C17.3 14.1475 18 12.4475 18 10.6475C18 6.24746 14.4 2.64746 10 2.64746ZM14.9 16.9475L3.7 5.74746C2.6 7.04746 2 8.74746 2 10.6475C2 15.0475 5.6 18.6475 10 18.6475C11.9 18.6475 13.6 18.0475 14.9 16.9475Z" />
    </svg>
  );
};

export default CancelIcon;